import ApiUtils from '../../utils/ApiUtils';
import AccountsStore from '../../stores/AccountsStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import FavouritesActionCreator from '../../actions/AccountsActionCreator/FavouritesActionCreator';
import {
  setSMEBackUrl,
  setMandateToEdit,
  setPaymentToEditById,
} from '../../actions/MoveMoneySMEActionCreator';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';

const ROUTE_MANAGE_PAYMENT = 'WEB-MANAGE-PAYMENT';

export const handleEdit = (mandate) => {
  setMandateToEdit(mandate);
  setSMEBackUrl(ROUTE_MANAGE_PAYMENT);
  InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY-PAYMENTS');
};

export const handleEditById = (paymentsType, paymentToEdit) => {
  setPaymentToEditById(paymentsType, paymentToEdit);
  setSMEBackUrl(ROUTE_MANAGE_PAYMENT);
  InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY-PAYMENTS');
};

export const getSessionInfo = (session) => ({
  clientContext: ApiUtils.getApiClientContext(),
  accessToken: session.accessToken,
  bankId: ApiUtils.getBankId(),
});

export const getSelectedAccount = (id) => {
  const findAccount = AccountsStore.getAccountDetail(id);
  return findAccount.id ? findAccount : undefined;
};

export const getAccountsToFilterOn = (id) => {
  const accounts = AccountsStore.getAll();
  if (FavouritesStore.isLargeCustomer()) {
    const selectedAccount = getSelectedAccount(id);
    if (
      selectedAccount &&
      !accounts.some((acc) => acc.id === selectedAccount.id)
    ) {
      return accounts.concat(selectedAccount);
    } else {
      return accounts;
    }
  }
  return accounts;
};

export const handleChooseAccountFromPicker = (e) => {
  e.preventDefault();
  FavouritesActionCreator.saveAccountPickerActions({
    backUrl: 'WEB-MANAGE-PAYMENT',
    onSelectAccount: () => {
      InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT');
    },
  });
  InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-PICKER');
};
